// import { Avatar, Button, Dropdown } from "antd";
// import { DownOutlined } from "@ant-design/icons";
// import React, { useState, useEffect } from "react";
// import { ReactComponent as NotificationIcon } from "../../../assets/svgs/notification.svg";
// import { ReactComponent as Profile } from "../../../assets/svgs/profile.svg";
// import { ReactComponent as Logout } from "../../../assets/svgs/logout.svg";
// import { Link, useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { logout } from "../../../redux/auth/authSlice";
// import NotificationList from "../DailogBox/NotificationDialogBox"; // Import the notification list component

// const mockUnseenNotificationCount = () => {
//   return Math.floor(Math.random() * 10);
// };

// const Header = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { user } = useSelector((state) => state.auth);
//   const [unSeenNotification, setUnSeenNotification] = useState(0);
//   const [showNotifications, setShowNotifications] = useState(false);

//   useEffect(() => {
//     const fetchNotifications = () => {
//       const count = mockUnseenNotificationCount();
//       setUnSeenNotification(count);
//     };

//     fetchNotifications();
//     const intervalId = setInterval(fetchNotifications, 30000);

//     return () => clearInterval(intervalId);
//   }, []);

//   const handleLogout = () => {
//     dispatch(logout());
//     navigate("/organization/login");
//   };

//   const items = [
//     {
//       label: (
//         <Link to={"/profile"}>
//           <div className="flex gap-x-2 items-center font-bold">
//             <Profile className="w-4 h-4" />
//             <span>Profile</span>
//           </div>
//         </Link>
//       ),
//       key: "0",
//     },
//     {
//       type: "divider",
//     },
//     {
//       label: (
//         <div
//           className="flex gap-x-2 items-center font-bold"
//           onClick={handleLogout}
//         >
//           <Logout className="w-4 h-4" />
//           <span>Logout</span>
//         </div>
//       ),
//       key: "1",
//     },
//   ];

//   return (
//     <div className="flex justify-between items-center bg-white px-4 pt-4 pb-3">
//       <div className="text-xl font-semibold">{user.name}</div>

//       <div className="flex items-center gap-x-6">
//         <div className="relative mt-2">
//           <Button
//             icon={<NotificationIcon className="w-16 h-16" />}
//             type="text"
//             onClick={() => setShowNotifications(true)}
//             className="relative"
//           />
//           {unSeenNotification > 0 && (
//             <div className="absolute -top-3 -right-3 translate-x-1/2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
//               {unSeenNotification}
//             </div>
//           )}

//           {showNotifications && (
//             <div className="fixed top-16 right-8 z-50">
//               <NotificationList onClose={() => setShowNotifications(false)} />
//             </div>
//           )}
//         </div>

//         <Dropdown
//           placement="bottom"
//           arrow={{ pointAtCenter: true }}
//           menu={{ items }}
//           trigger={["click"]}
//         >
//           <a onClick={(e) => e.preventDefault()}>
//             <div className="flex items-center gap-x-2">
//               <Avatar
//                 size={40}
//                 style={{ background: "gray" }}
//                 src="https://api.dicebear.com/7.x/miniavs/svg?seed=1"
//               />
//               <div className="leading-tight">
//                 <div className="text-sm text-black font-semibold">
//                   {user?.name}
//                 </div>
//                 <div className="text-xs text-gray-400 font-light">Admin</div>
//               </div>
//               <DownOutlined className="text-black text-sm" />
//             </div>
//           </a>
//         </Dropdown>
//       </div>
//     </div>
//   );
// };

// export default Header;

import { Avatar, Button, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import { ReactComponent as NotificationIcon } from "../../../assets/svgs/notification.svg";
import { ReactComponent as Profile } from "../../../assets/svgs/profile.svg";
import { ReactComponent as Logout } from "../../../assets/svgs/logout.svg";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../redux/auth/authSlice";
import NotificationList from "../DailogBox/NotificationDialogBox";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import {ReactComponent as Logo} from "../../../assets/svgs/avatar_green.svg";
const Header = ({ sidebarWidth = 280 }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [unSeenNotification, setUnSeenNotification] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);

  const fetchUnreadCount = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_UNREAD_NOTIFICATION_COUNT,
      });
      if (response && response.success) {
        setUnSeenNotification(response.count);
      }
    } catch (error) {
      console.error("Failed to fetch unread count:", error);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    const intervalId = setInterval(fetchUnreadCount, 30000);

    return () => clearInterval(intervalId);
  }, []);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/organization/login");
  };


  const items = [
    {
      label: (
        <Link to={"/profile"}>
          <div className="flex gap-x-2 items-center font-bold">
            <Profile className="w-4 h-4" />
            <span> Profile</span>
          </div>
        </Link>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <div
          className="flex gap-x-2 items-center font-bold"
          onClick={handleLogout}
        >
          <Logout className="w-4 h-4" />
          <span>Logout</span>
        </div>
      ),
      key: "1",
    },
  ];

  return (
    <>
      <div className="fixed top-0 flex justify-between items-center bg-white px-4 pt-4 pb-3 z-30"
      style={{
          boxShadow: "41px 12px 23.2px 0px rgba(48, 183, 146, 0.12)",
          left: `${sidebarWidth}px`,
          width: `calc(100% - ${sidebarWidth}px)`,
        }}
      >
        <div className="text-xl font-semibold">{user?.name}</div>

        <div className="flex items-center gap-x-6">
          <div className="relative">
            <Button
              icon={<NotificationIcon className="w-6 h-6" />}
              type="text"
              onClick={() => setShowNotifications(!showNotifications)}
              className="relative"
            />
            {unSeenNotification > 0 && (
              <div className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-semibold">
                {unSeenNotification}
              </div>
            )}
          </div>

          <Dropdown
            placement="bottomRight"
            arrow={{ pointAtCenter: true }}
            menu={{ items }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <div className="flex items-center gap-x-2 cursor-pointer">
                <Logo
                  className="w-10 h-10"
                />
                <div className="leading-tight">
                  <div className="text-sm text-black font-semibold">
                    {user?.name}
                  </div>
                  <div className="text-xs text-gray-400 font-light">Admin</div>
                </div>
                <DownOutlined className="text-black text-sm" />
              </div>
            </a>
          </Dropdown>
        </div>
      </div>

      {/* Notification Panel */}
      {showNotifications && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-40"
            onClick={() => setShowNotifications(false)}
          />
          {/* Notification List */}
          <div className="fixed top-20 right-8 z-50 shadow-lg animate-fadeIn">
            <NotificationList
              onClose={() => setShowNotifications(false)}
              unreadCount={unSeenNotification}
              setUnreadCount={setUnSeenNotification}
            />
          </div>
        </>
      )}
    </>
  );
};

export default Header;
